import { Tabs } from "../../shared";
import Form from "./Form";
import { UPDATE_ABBVIE_ID_CONFIGURED_APP } from "./query";
const SubComponent = ({ data }) => {
    const { id } = data;

    return (
        <Tabs
            tabItems={[
                {
                    id: `update-${id}`,
                    name: "Update Configured App",
                    content: (
                        <>
                            <h5 className="mb-4">Update AbbVie ID Configured App</h5>
                            <Form
                                query={UPDATE_ABBVIE_ID_CONFIGURED_APP}
                                formType="update"
                                formData={data}
                            />
                        </>
                    ),
                },
            ]}
        />
    );
};

export default SubComponent;
